@if (roleService.can('read', 'admin') | async) {
  <mat-card style="margin-bottom: 1em">
    <mat-card-header>
      <div mat-card-avatar><i class="fa fa-book fa-2x"></i></div>
      <mat-card-title>Agendamiento</mat-card-title>
      <mat-card-subtitle>Configura aspectos generales del agendamiento</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="formBooking">
        <ng-container formGroupName="preferences">
          <mat-form-field>
            <mat-label>Tipo de Agendamiento</mat-label>
            <mat-select placeholder="Tipo de Agendamiento" formControlName="booking_type" name="booking_type" autocomplete="off" multiple="false" required>
              <mat-option *ngFor="let booking_type of booking_types" [value]="booking_type.id">
                {{booking_type.name}}
              </mat-option>
            </mat-select>
            <mat-hint>Seleccione tipo de agendamiento</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Formato de Agendamiento</mat-label>
            <mat-select placeholder="Formato de Agendamiento" formControlName="booking_format" name="booking_format" autocomplete="off" multiple="false" required>
              <mat-option *ngFor="let booking_format of booking_formats" [value]="booking_format.id">
                {{booking_format.name}}
              </mat-option>
            </mat-select>
            <mat-hint>Seleccione formato de agendamiento</mat-hint>
          </mat-form-field>
          <mat-form-field *ngIf="formBooking.get('preferences.booking_type').value === 'professional'">
            <mat-label>Profesional</mat-label>
            <mat-select placeholder="Profesional" formControlName="booking_role_ids" name="booking_role_ids" autocomplete="off" required [multiple]="true">
              <mat-option *ngFor="let role of roles()" [value]="role.id">
                {{role.name}}
              </mat-option>
            </mat-select>
            <mat-hint>El rol que se usará para el agendamiento según profesionales</mat-hint>
          </mat-form-field>
          <mat-checkbox formControlName="temp_identifier" style="margin-bottom: 10px;">Identificador opcional en agendamiento</mat-checkbox>

          <ng-container formGroupName="booking_mail">
            <mat-form-field>
              <mat-label>Email Agendado</mat-label>
              <textarea matInput placeholder="<h5>Hola {nombre}</h5><p>¡Tu cita ya fue agendada!</p>" formControlName="text"></textarea>
              <mat-hint>Contenido del email de agendamiento <i class="fa fa-question-circle" matTooltip="Puedes utilizar los siguientes placeholders: {nombre},{patente},{marca},{modelo},{requerimiento},{fecha},{hora}. Tambien puedes utilizar tus campos personalizados de orden (ej: {numero_de_siniestro}) y HTML Básico."></i></mat-hint>
            </mat-form-field>
            <mat-checkbox formControlName="enable_booked_mail" style="margin-bottom: 10px;">Activar envío de mail Agendado</mat-checkbox>
            <mat-form-field>
              <mat-label>Email Confirmación</mat-label>
              <textarea matInput placeholder="<h2>Hola {nombre}</h2><p>Te recordamos que mañana a las {hora} tienes una cita</p>" formControlName="confirm_text"></textarea>
              <mat-hint>Contenido del email de confirmación <i class="fa fa-question-circle" matTooltip="Puedes utilizar los siguientes placeholders: {nombre},{patente},{marca},{modelo},{requerimiento},{fecha},{hora}. Tambien puedes utilizar tus campos personalizados de orden (ej: {numero_de_siniestro}) y HTML Básico."></i></mat-hint>
            </mat-form-field>
            <mat-checkbox formControlName="enable_confirmed_mail" style="margin-bottom: 10px;">Activar envío de mail Confirmación</mat-checkbox>
            <mat-form-field>
              <mat-label>URL Banner</mat-label>
              <input matInput placeholder="Banner" formControlName="banner_url" autocomplete="off">
              <mat-hint>URL de la imagen a mostrar en el correo</mat-hint>
              <button mat-icon-button matSuffix (click)="banner.click()">
                <mat-icon>link</mat-icon>
              </button>
              <input type="file" style="display: none" name="image" #banner (change)="onFileChange($event,formBooking)">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Estilo Banner</mat-label>
              <mat-select placeholder="Estilo Banner" formControlName="banner_style">
                <mat-option value="">Seleccione</mat-option>
                <mat-option value="contain">Contener</mat-option>
                <mat-option value="cover">Cubrir</mat-option>
              </mat-select>
              <mat-hint>Estilo CSS para el banner</mat-hint>
            </mat-form-field>
          </ng-container>
          <ng-container formGroupName="booking_addon">
            <mat-form-field>
              <mat-label>Dominios</mat-label>
              <textarea matInput placeholder="https://www.example.com http://*.otherexample.com" formControlName="allowed_domains"></textarea>
              <mat-hint>Dominios permitidos para integrar el addon de agendamiento<i class="fa fa-question-circle" matTooltip="En caso de proporcionar más de uno, deben estar separados por espacios."></i></mat-hint>
            </mat-form-field>
  
            <div class="picker">
              Color de fondo:
              <input type="color" formControlName="background_color">
            </div>
            <mat-form-field hidden >
              <mat-label>Color de fondo</mat-label>
              <input matInput placeholder="#FFFFFF" formControlName="background_color" autocomplete="off" >
            </mat-form-field>
          </ng-container>
        </ng-container>
      </form>
    </mat-card-content>
  </mat-card>
  <ng-template #itemTemplate let-item>
    {{item.name}}
  </ng-template>
  
}

<div class="holydays">
  <mat-card>
    <mat-card-header>
      <div mat-card-avatar><i class="fa fa-book fa-2x"></i></div>
      <mat-card-title>Preferencias</mat-card-title>
      <mat-card-subtitle>Administre sus preferencias por local</mat-card-subtitle>
      <div class="locale-selector">
        <mat-form-field>
          <mat-label>{{companyService.getText('location')}}</mat-label>
          <mat-select placeholder="{{companyService.getText('location')}}" [(ngModel)]="locationId" name="report_role_ids" autocomplete="off" (ngModelChange)="setLocation($event)">
            <mat-option *ngFor="let location of locations" [value]="location.id">
              {{location.name}}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-full">
          <div class="workdays">
            <h4>Días de Recepción</h4>
            <form [formGroup]="bookingDays">
              <ng-container>
                <div *ngFor="let day of days; let i = index" formArrayName="days">
                  @let formgroup = (bookingDays.controls['days'] | formGroup:true).controls[i];
                  <ng-container [formGroup]="formgroup">
                    <div class="row-days">
                      <div class="col-days">
                        <mat-checkbox formControlName="enabled">{{day}}</mat-checkbox>
                      </div>
                      <div class="col-days">
                        <mat-form-field>
                          <mat-label>Hora Inicio</mat-label>
                          <input matInput placeholder="Horario Inicio" required formControlName="start_time" [errorStateMatcher]="matcher">
                          @if (!formgroup.get('start_time').valid) {
                            <mat-error>Hora inválida. Formato HH:MM. Ej: 08:20</mat-error>
                          }
                          <mat-hint>Formato HH:MM. Ej: 08:20</mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-days">
                        <mat-form-field>
                          <mat-label>Horario Termino</mat-label>
                          <input matInput placeholder="Horario Término" required formControlName="end_time">
                          @if (!formgroup.get('end_time').valid) {
                            <mat-error>Hora inválida. Formato HH:MM. Ej: 18:20</mat-error>
                          }
                          <mat-hint>Formato HH:MM. Ej: 18:20</mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-days">
                        <mat-form-field>
                          <mat-label>Limite Minutos</mat-label>
                          <input matInput type="number" placeholder="Limite Minutos" formControlName="max_hours">
                          <mat-hint>Tiempo máximo de trabajo</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                  </ng-container>
                </div>
                </ng-container>
            </form>
          </div>
        </div>
        <div class="col-full">
          <div class="workdays">
            <h4>Días Laborables</h4>
            <form [formGroup]="workingDays">
              <ng-container>
                <div *ngFor="let day of days; let i = index" formArrayName="work_days">
                  @let formgroup = (workingDays.controls['work_days'] | formGroup:true).controls[i];
                  <ng-container [formGroup]="formgroup">
                    <div class="row-days">
                      <div class="col-days">
                        <mat-checkbox formControlName="enabled">{{day}}</mat-checkbox>
                      </div>
                      <div class="col-days">
                        <mat-form-field>
                          <mat-label>Horario Inicio</mat-label>
                          <input matInput placeholder="Horario Inicio" required formControlName="start_time">
                          @if (!formgroup.get('start_time').valid) {
                            <mat-error>Hora inválida. Formato HH:MM. Ej: 08:20</mat-error>
                          }
                          <mat-hint>Formato HH:MM. Ej: 08:20</mat-hint>
                        </mat-form-field>
                      </div>
                      <div class="col-days">
                        <mat-form-field>
                          <mat-label>Horario Termino</mat-label>
                          <input matInput placeholder="Horario Término" required formControlName="end_time">
                          @if (!formgroup.get('end_time').valid) {
                            <mat-error>Hora inválida. Formato HH:MM. Ej: 18:20</mat-error>
                          }
                          <mat-hint>Formato HH:MM. Ej: 18:20</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </form>
          </div>
        </div>
        <div class="col-full">
          <div class="hours">
            <h4>Horario de Recepción</h4>
            <form [formGroup]="workHours">
              <mat-form-field>
                <mat-label>Intervalo entre agendamientos (minutos)</mat-label>
                <input matInput placeholder="Intervalo entre agendamientos (minutos)" type="number" required formControlName="time_interval" pattern="\d*">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Máx. Agendamientos Simultáneos</mat-label>
                <input matInput type="number" placeholder="Máx. Agendamientos Simultáneos" required formControlName="max_bookings" pattern="\d*">
                <mat-hint>En modo según profesional el valor se establece en 1.</mat-hint>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Máx. Agendamientos Diarios</mat-label>
                <input matInput type="number" placeholder="Máx. Agendamientos Diarios" required formControlName="max_bookings_per_day" pattern="\d*">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Email Agendamiento</mat-label>
                <input matInput type="text" placeholder="Email Agendamiento" [value]="email+'+'+locationId+'@controlcar.cl'" disabled>
              </mat-form-field>
              <h4>Mailing</h4>
              <fieldset formGroupName="mailing">
                <mat-form-field>
                  <mat-label>Dirección</mat-label>
                  <input matInput type="text" placeholder="Dirección" formControlName="address">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Teléfono</mat-label>
                  <input matInput type="text" placeholder="Teléfono" formControlName="phone">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Correo</mat-label>
                  <input matInput type="text" placeholder="Correo" formControlName="email">
                </mat-form-field>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
